import { gql, TypedDocumentNode } from '@common/hooks';
import { TimekeepingHolidayFragment } from '@common/graphql/schema';

export const TimekeepingHoliday: TypedDocumentNode<TimekeepingHolidayFragment> = gql`
  fragment TimekeepingHoliday on CalendarTrackerOrganizationDayEvent {
    id
    name
    startDay
    startTime
    endDay
    endTime
    status
    inPast
    originEvent {
      startDay
      startTime
      endDay
      endTime
    }
  }
`;
